import { AuthService } from '@aipb/shared/auth';
import { Injectable } from '@angular/core';
import { ROLE_PERSONAL_CONTENT, ROLE_PERSONAL_CONTENT_COLLECTIONS } from './personal-content-auth.constants';

@Injectable({
  providedIn: 'root'
})
export class PersonalContentPermissionService {
  constructor(private auth: AuthService) {}

  get canUseCollections() {
    return this.auth.hasRole(ROLE_PERSONAL_CONTENT_COLLECTIONS);
  }

  get canUsePersonalContent() {
    return this.auth.hasRole(ROLE_PERSONAL_CONTENT);
  }
}
